import { useEffect } from 'react'
import { Status } from 'redux/features/parcelle/slice'
import pushToDataLayer from 'utils/pushToDataLayer'

interface Params {
  status: Status
  event: 'rechercheBiensAVendre' | 'rechercheEtudierMarche'
}

export default function useTrackRecherche({ status, event }: Params) {
  useEffect(() => {
    if (status === Status.ShowParcelleResults) {
      pushToDataLayer({
        event,
      })
    }
  }, [status, event])
}
